import Cookies from 'js-cookie';
/**
 * 从cookie获取用户信息
 * @returns
 */
export default function getCookieUserInfo() {
    var csmbplogintype = Cookies.get('csmbplogintype');
    var loginType = '';
    if (csmbplogintype === '-3') {
        loginType = 'OA';
    }
    return {
        loginType: loginType,
    };
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/getCookieUserInfo.js
// module id = null
// module chunks = 